/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect, useCallback } from 'react';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import { Layout } from 'antd';
import routes from './routes';
import history from '../services/history';
import LoginPage from '../pages/Login/Login';
import './style.scss';
import Sidebar from '../layout/sidebar';
import NotFoundPage from '../pages/NotFound';
import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';
import { authenticateCurrentUser } from '../services/auth';
import { connect } from 'react-redux';
import get from 'lodash/get';
// import { Hub } from 'aws-amplify';
import { Hub } from '@aws-amplify/core';
import ForgotPassword from '../pages/Login/ForgotPassword';
import ResetPassword from '../pages/Login/ResetPassword';
import SignUp from '../pages/Login/SignUp';
import EquipmentCheckComingsoon from '../components/EquipmentCheckComingsoon';
import TechnicalPDFViewer from '../components/CRCE Technical/TechnicalPDFViewer';
import HeatProfilePDFViewer from '../components/Heatprofile/HeatProfilePDFViewer';
import HeatProfileImageViewer from '../components/Heatprofile/HeatProfileImageViewer';
import { ModernLayout } from '../layouts/modern';
import { shouldExcludeFromRedirect } from '../utils/routeHelpers';
import NoAccessPage from '../pages/NoAccessPage';
import { NO_ACCESS_GROUP_KEY } from '../components/AddUserModal';
import { setUserAccessList } from '../redux/pihEquipmentDetails/action';

const AppContainer = (props) => {
  const { onSetUserAccessList } = props;
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isWebAcess, setIsWebAcess] = useState(false);
  const [userAccess, setUserAccess] = useState([]);
  const [isShowProjectData, setIsShowProjectData] = useState(false);

  const syncSessionGroupsFromUser = useCallback((data) => {
    const raw = data.signInUserSession.accessToken.payload['cognito:groups'];
    const groups = normalizeCognitoGroups(raw);
    setUserAccess(groups);
    const webFlag = hasWebPageStorageFlag(groups);
    setIsWebAcess(webFlag);
    localStorage.setItem('is-web-page', webFlag ? 'true' : 'false');
  }, []);

  const applyAuthenticatedUser = useCallback(
    (data) => {
      const groups = data.signInUserSession.accessToken.payload['cognito:groups'] || [];
      const hasWeb =
        groups?.includes('web-page') ||
        groups?.includes('web-page-without-create-project') ||
        groups?.includes('super-admin') ||
        groups?.includes('admin');
      setUserAccess(groups);
      localStorage.setItem('UserGroup', JSON.stringify(groups));
      localStorage.setItem('is-web-page', hasWeb ? 'true' : 'false');
      setIsWebAcess(!!hasWeb);
      onSetUserAccessList(groups);
      setIsAuthenticated(true);
    },
    [onSetUserAccessList],
  );

  /** Load Cognito session into React + Redux + localStorage (sidebar reads these). Runs on first mount and after Hub signIn. */
  const hydrateAuthFromSession = useCallback(async () => {
    const data = await authenticateCurrentUser();
    applyAuthenticatedUser(data);
  }, [applyAuthenticatedUser]);

  useEffect(() => {
    const removeHub = Hub.listen('auth', ({ payload }) => {
      const { event } = payload || {};
      switch (event) {
        case 'cognitoHostedUI':
          break;
        case 'signIn': {
          const isOtpFlow = sessionStorage.getItem('otp_validation_in_progress') === 'true';
          if (!isOtpFlow) {
            hydrateAuthFromSession().catch(() => {
              setIsAuthenticated(!!localStorage.getItem('ap_idToken'));
            });
          }
          break;
        }
        case 'signOut':
          setIsAuthenticated(false);
          setUserAccess([]);
          onSetUserAccessList([]);
          sessionStorage.removeItem('otp_validation_in_progress');
          break;
        default:
          break;
      }
    });
    return () => {
      removeHub();
    };
  }, [hydrateAuthFromSession, onSetUserAccessList]);

  /** Handling Reloadin or Refreshing page (from browser) */
  // useEffect(() => {
  //   const pageAccessedByReload = (
  //     (window.performance.PerformanceNavigationTiming && window.performance.PerformanceNavigationTiming.type === 1) ||
  //     window.performance
  //       .getEntriesByType('navigation')
  //       .map((nav) => nav.type)
  //       .includes('reload')
  //   );

  //   console.log(pageAccessedByReload);
  //   if (pageAccessedByReload) {
  //       history.push('/');
  //   }
  // }, [])

  useEffect(() => {
    const element = document.getElementById('body-wrapper');
    const theme = sessionStorage.getItem('theme');
    if (theme === 'True') {
      element.classList.add('light-theme');
    } else {
      element.classList.remove('light-theme');
    }

    const currentPath = window.location.pathname;
    const isModernRoute = routes.some(
      (route) =>
        route.layout === ModernLayout &&
        (route.exact ? currentPath === route.path : currentPath.startsWith(route.path)),
    );

    let cancelled = false;

    const handleInitialAuthFailure = () => {
      if (cancelled) return;
      /* Login can finish while this initial check was still in flight; do not wipe fresh tokens. */
      if (localStorage.getItem('ap_idToken')) {
        hydrateAuthFromSession()
          .then(() => {})
          .catch(() => {
            if (!cancelled) setIsAuthenticated(false);
          });
        return;
      }
      setIsAuthenticated(false);
      localStorage.clear();
      sessionStorage.clear();
    };

    hydrateAuthFromSession()
      .then(() => {
        if (cancelled) return;
        if (isModernRoute || shouldExcludeFromRedirect()) {
          console.log('[Routes] On modern/excluded route, skipping redirect:', currentPath);
        }
      })
      .catch(handleInitialAuthFailure);

    return () => {
      cancelled = true;
    };
  }, [hydrateAuthFromSession]);

  /** Same rule as PublicRoute: sole group `no-access` → limited shell only. */
  const isNoAccessUser =
    Array.isArray(userAccess) &&
    userAccess.length === 1 &&
    userAccess.includes(NO_ACCESS_GROUP_KEY);

  return (
    <Router history={history}>
      <Switch>
        <PublicRoute
          userAccess={userAccess}
          isWebAcess={isWebAcess}
          exact
          path="/login"
          isLogin={isAuthenticated}
          component={LoginPage}
        />
        <PublicRoute
          userAccess={userAccess}
          isWebAcess={isWebAcess}
          exact
          path="/signup"
          isLogin={isAuthenticated}
          component={SignUp}
        />
        <PublicRoute
          userAccess={userAccess}
          isWebAcess={isWebAcess}
          path="/forgot-password"
          isLogin={isAuthenticated}
          component={ForgotPassword}
        />
        <PublicRoute
          userAccess={userAccess}
          isWebAcess={isWebAcess}
          path="/reset-password"
          isLogin={isAuthenticated}
          component={ResetPassword}
        />
        <Route path="/notFound" component={NotFoundPage} />
        <Route
          path="/asset-management/maintenance-history"
          component={isAuthenticated ? EquipmentCheckComingsoon : LoginPage}
        />
        <Route path="/TechnicalPage/pdf/:id" component={TechnicalPDFViewer} />
        <Route path="/heat-profile/pdf/:id" component={HeatProfilePDFViewer} />
        <Route path="/heat-profile/image/:id" component={HeatProfileImageViewer} />

        {/* No-access users: only this page, no sidebar; redirect web-page/dashboard etc. here */}
        <Route
          exact
          path="/no-access"
          render={() =>
            isAuthenticated && isNoAccessUser ? (
              <NoAccessPage />
            ) : (
              <Redirect to={isAuthenticated ? '/projects' : '/login'} />
            )
          }
        />

        {isAuthenticated && isNoAccessUser ? (
          <Redirect to="/no-access" />
        ) : (
          <>
            {/* ModernLayout routes render independently with their own sidebar - MUST be first */}
            {routes
              .filter((route) => {
                // Check if route uses ModernLayout by comparing function or checking name
                const isModern = route.layout === ModernLayout || 
                                (route.layout && (route.layout.name === 'ModernLayout' || route.layout.displayName === 'ModernLayout'));
                return isModern;
              })
              .map((route) => (
                <Route
                  key={route.path}
                  path={route.path}
                  exact={route.exact}
                  render={(props) => {
                    // For modern routes, allow rendering even if auth is still checking
                    // The component will handle auth state
                    if (!isAuthenticated) {
                      // Check if user is actually logged in (for new tabs)
                      const token = localStorage.getItem('ap_idToken');
                      if (!token) {
                        return <Redirect to="/login" />;
                      }
                      // If token exists, allow rendering (auth check is in progress)
                    }
                    return (
                      <route.layout {...props}>
                        <route.component
                          {...props}
                          isAuthenticated={isAuthenticated}
                          isShowProjectData={isShowProjectData}
                          setIsShowProjectData={setIsShowProjectData}
                        />
                      </route.layout>
                    );
                  }}
                />
              ))}

            {/* Legacy routes use the existing Layout wrapper with legacy Sidebar */}
            {/* Render legacy routes - this Route only matches if no ModernLayout route matched above */}
            <Route
              render={({ location }) => {
                // CRITICAL: Check if current path is a ModernLayout route FIRST
                const isModernLayoutRoute = routes.some(
                  (route) => {
                    const layoutMatches = route.layout === ModernLayout;
                    const pathMatches = route.exact 
                      ? location.pathname === route.path 
                      : location.pathname.startsWith(route.path);
                    return layoutMatches && pathMatches;
                  }
                );
                
                // If it's a modern layout route, don't render legacy wrapper at all
                if (isModernLayoutRoute) {
                  console.log('[Routes] Blocking legacy wrapper - ModernLayout route detected:', location.pathname);
                  return null;
                }
                
                // Check if it's a known legacy route
                const isLegacyRoute = routes.some(
                  (route) => route.layout !== ModernLayout && 
                  (route.exact ? location.pathname === route.path : location.pathname.startsWith(route.path))
                );
                
                // Only render legacy wrapper for legacy routes
                if (!isLegacyRoute && location.pathname !== '/notFound') {
                  return null; // Let 404 or other handlers catch it
                }
                
                // Render legacy layout wrapper for legacy routes only
                return (
                  <Layout className="h-100">
                    <Sidebar setIsShowProjectData={setIsShowProjectData} />
                    <Layout.Content className="h-100 pt-3 px-4">
                      <Switch location={location}>
                        {routes
                          .filter((route) => route.layout !== ModernLayout)
                          .map((route) => (
                            <PrivateRoute
                              key={route.path}
                              path={route.path}
                              exact={route.exact}
                              isLogin={isAuthenticated}
                              component={(props) => (
                                <route.layout {...props}>
                                  <route.component
                                    {...props}
                                    isAuthenticated={isAuthenticated}
                                    isShowProjectData={isShowProjectData}
                                    setIsShowProjectData={setIsShowProjectData}
                                  />
                                </route.layout>
                              )}
                            />
                          ))}
                        <PrivateRoute
                          path="*"
                          component={() => <Redirect to="/notFound" />}
                        />
                      </Switch>
                    </Layout.Content>
                  </Layout>
                );
              }}
            />
          </>
        )}
      </Switch>
    </Router>
  );
};

const mapStateToProps = ({ auth }) => {
  const isLogin = get(auth, 'isLogin', false);
  return {
    isLogin,
  };
};

const mapDispatchToProps = {
  onSetUserAccessList: setUserAccessList,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);
// export default AppContainer;
